import React, { useState } from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridContainerGridItemButtonIncluirLinha,
    GridItem1xs2,
    GridItem2,
    GridItem2xs6,
    GridItem2xs6NotIsXsDownScreen,
    GridItem2xs12,
    GridItem3xs6,
    GridItem3xs12,
    GridItem5,
    GridItem4xs10,
    GridItem4xs12,
    GridItem5xs12,
    GridItem6,
    GridItem7,
    GridItem7xs10,
    GridItem7xs10NotIsXsDownScreen,
    GridItem10,
    GridItem12,
    GridItem12mt12IsXsDownScreen,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoDiaDiaList from '../../../business-rules/List/tipoDiaDiaList'

import {
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoDiaDia,
    rowPertentePageDiaDia,
    setPageInclusaoDiaDia,
    Familiar,
    IconButtonClearEntradaDadosDiaDia,
    TipoDiaDia,
    Valor,
    ValorNaAposentadoria,
    TipoPeriodicidadePagto,
    DespesaPessoal,
    PeriodoDiaDia,
    AlterarPeriodoDiaDia,
    MesAnoInicial,
    MesAnoFinal,
    DescricaoDiversasOutros,
} from '../despesas-form/DespesasCompDiaDia'

import {
    incrementaContDiaDia,
    processaRegistrosDefaultIniciaisDiaDia,
    processaAlteracaoDiaDiaAlterarPeriodoDiaDia,
    calculaTotaisDiaDia,
} from '../despesas-form/DespesasServiceDiaDia'

import {
    processaFormRegistrosDefaultIniciaisSortAscFamiliar
} from './FormService'

import DespesasFormDiaDiaItem from '../despesas-form/DespesasFormDiaDiaItem'


const ExpandirExcluir = ({values, handleChange, setFieldValue, linhaTipoLicenca, jsonConfiguracao, title,
    arrayHelpers, item, ind, tipoDiaDiaSelecionado, setExpandiu }) => {

    return (
        <GridContainer>
            {item.tipoDiaDia && ((!item.alterarPeriodoDiaDia &&
            (
                item.familiar === HARDCODE.idFamiliarCliente ||
                item.familiar === HARDCODE.idFamiliarConjuge
            )) ||
            item.alterarPeriodoDiaDia 
            ) && (
                <GridItem12mt12IsXsDownScreen/>
            )}
            <GridItem6
                className="mt-2"
            >
                <CustomizedDialogsPopup
                    maxWidth="sm"
                    popupTitle={title}
                    tooltipTitle={LABEL.expandir}
                    PopupButton={IconButtonMaisInformacoes}
                    popupButtonDestaque={false}
                    DialogContentClassName={CLASSNAME().dialogContentClassNameFormExpandir}
                    popupComponent={
                        <DespesasFormDiaDiaItem
                            values={values}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                            arrayHelpers={arrayHelpers}
                            linhaTipoLicenca={linhaTipoLicenca}
                            jsonConfiguracao={jsonConfiguracao}
                            tipoDiaDiaSelecionado={tipoDiaDiaSelecionado}
                            item={item}
                            ind={ind}
                            simplificado={true}
                        />
                    }
                    open={setExpandiu}
                    afterClose={setExpandiu}
                />
            </GridItem6>
            <GridItem6
                className="mt-2"
            >
                <IconButtonClearEntradaDadosDiaDia
                    values={values}
                    setFieldValue={setFieldValue}
                    item={item}
                    ind={ind}
                    arrayHelpers={arrayHelpers}
                />
            </GridItem6>
        </GridContainer>
    )
}

const FormFormDiaDia = ({ values, handleChange, setFieldValue, linhaTipoLicenca, jsonConfiguracao, title }) => {

    const [expandiu, setExpandiu] = useState(false)
    
    calculaTotaisDiaDia(values, jsonConfiguracao)

    useSingleton(async () => {

        processaFormRegistrosDefaultIniciaisSortAscFamiliar(values, values.totalDiaDia, processaRegistrosDefaultIniciaisDiaDia, values.diaDia)

        values.pageDiaDia = obtemPage(values.pageDiaDiaList, HARDCODE.idFamiliarPage)
    })

    salvaPage(values.pageDiaDia, values.pageDiaDiaList, HARDCODE.idFamiliarPage)

    values.diaDiaPagination = values.diaDia

    const isXsDownScreen = IsXsDownScreen()



    return (
        <FieldArray name="diaDia">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.diaDia?.map((item, ind) => {

                            if (rowPertentePageDiaDia(values, ind)) {

                                let tipoDiaDiaSelecionado = pesquisaList(tipoDiaDiaList, item.tipoDiaDia)

                                //if (item.alterarPeriodoDiaDia) {

                                processaAlteracaoDiaDiaAlterarPeriodoDiaDia(item, values)
                                //}

                                return (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <GridContainer>
                                            <GridItem4xs10>
                                                <GridContainer>
                                                    <GridItem5>
                                                        <Familiar
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem5>
                                                    
                                                    <GridItem7>
                                                        <TipoDiaDia
                                                            TextFieldNumberSelectTipoDiaDia={
                                                                TextFieldNumberSelect
                                                            }
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem7>
                                                </GridContainer>
                                            </GridItem4xs10>

                                            {item.tipoDiaDia
                                                ?
                                                    <GridItem7xs10>
                                                        <GridContainer>
                                                            <GridItem2xs6>
                                                                <Valor
                                                                    values={values}
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem2xs6>
                                                            {!item.alterarPeriodoDiaDia &&
                                                            (
                                                                item.familiar === HARDCODE.idFamiliarCliente ||
                                                                item.familiar === HARDCODE.idFamiliarConjuge
                                                            )
                                                                ?
                                                                    <GridItem2xs6>
                                                                        <ValorNaAposentadoria
                                                                            item={item}
                                                                            ind={ind}
                                                                            handleChange={handleChange}
                                                                            //labelCurto={true}
                                                                            expandiu={expandiu}
                                                                        />
                                                                    </GridItem2xs6>
                                                                :
                                                                    <GridItem2xs6NotIsXsDownScreen/>
                                                            }

                                                            <GridItem3xs6>
                                                                <TipoPeriodicidadePagto
                                                                    values={values}
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange} 
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem3xs6>
                                                            
                                                            <GridItem5xs12>
                                                                <DescricaoDiversasOutros
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange} 
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem5xs12>
                                                        </GridContainer>
                                                    </GridItem7xs10>
                                                :
                                                    <GridItem7xs10NotIsXsDownScreen />
                                            }

                                            {!isXsDownScreen && (
                                                <GridItem1xs2>
                                                    <ExpandirExcluir
                                                        values={values}
                                                        handleChange={handleChange}
                                                        setFieldValue={setFieldValue}
                                                        linhaTipoLicenca={linhaTipoLicenca}
                                                        jsonConfiguracao={jsonConfiguracao}
                                                        title={title}
                                                        arrayHelpers={arrayHelpers}
                                                        item={item}
                                                        ind={ind}
                                                        tipoDiaDiaSelecionado={tipoDiaDiaSelecionado}
                                                        setExpandiu={setExpandiu}
                                                    />
                                                </GridItem1xs2>
                                            )}
                                        </GridContainer>
                                        
                                        {item.tipoDiaDia && (
                                            <>
                                                <GridContainer>
                                                    {!isXsDownScreen && (
                                                        <GridItem4xs10/>
                                                    )}

                                                    <GridItem7xs10>
                                                        <GridContainer>
                                                            <GridItem2xs12
                                                                className={isXsDownScreen ? '' : 'mt-2'}
                                                            >
                                                                {tipoDiaDiaSelecionado.morte === "N" &&
                                                                tipoDiaDiaSelecionado.invalidez === "N" && 
                                                                !expandiu && (
                                                                    <DespesaPessoal
                                                                        values={values}
                                                                        item={item}
                                                                        ind={ind}
                                                                        handleChange={handleChange}
                                                                        labelCurto={true}
                                                                    /> 
                                                                )}
                                                            </GridItem2xs12>

                                                            {!isXsDownScreen && (
                                                                <GridItem2xs12/>
                                                            )}

                                                            <GridItem3xs12
                                                                className={isXsDownScreen ? '' : 'mt-2'}
                                                            >
                                                                {item.tipoPeriodicidadePagto !== HARDCODE.idTipoPeriodicidadeUnica &&
                                                                !expandiu && (
                                                                    <AlterarPeriodoDiaDia
                                                                        values={values}
                                                                        item={item}
                                                                        ind={ind}
                                                                        handleChange={handleChange}
                                                                    />
                                                                )}
                                                            </GridItem3xs12>

                                                            {item.alterarPeriodoDiaDia
                                                                ?
                                                                    <GridItem4xs12>
                                                                        <GridContainer>
                                                                            <GridItem6>
                                                                                <MesAnoInicial
                                                                                    values={values}
                                                                                    item={item}
                                                                                    ind={ind}
                                                                                    handleChange={handleChange} 
                                                                                    expandiu={expandiu}
                                                                                />
                                                                            </GridItem6>
                                                                            {!item.diaDiaIraOcorrerAteExpectativaVida  &&
                                                                            item.tipoPeriodicidadePagto !== HARDCODE.idTipoPeriodicidadeUnica&& (
                                                                                <GridItem6>
                                                                                    <MesAnoFinal
                                                                                        values={values}
                                                                                        item={item}
                                                                                        ind={ind}
                                                                                        handleChange={handleChange} 
                                                                                        expandiu={expandiu}
                                                                                    />
                                                                                </GridItem6>
                                                                            )}
                                                                        </GridContainer>
                                                                    </GridItem4xs12>
                                                                :
                                                                    <GridItem5xs12
                                                                        className={isXsDownScreen ? '' : 'mt-5'}
                                                                    >
                                                                        <PeriodoDiaDia/>
                                                                    </GridItem5xs12>
                                                            }
                                                        </GridContainer>
                                                    </GridItem7xs10>
                                                </GridContainer>

                                                {isXsDownScreen && (
                                                    <GridContainer>
                                                        <GridItem10/>
                                                        
                                                        <GridItem2
                                                            className={item.alterarPeriodoDiaDia ? 'mt--35' : 'mt--25'}
                                                        >
                                                            <ExpandirExcluir
                                                                values={values}
                                                                handleChange={handleChange}
                                                                setFieldValue={setFieldValue}
                                                                linhaTipoLicenca={linhaTipoLicenca}
                                                                jsonConfiguracao={jsonConfiguracao}
                                                                title={title}
                                                                arrayHelpers={arrayHelpers}
                                                                item={item}
                                                                ind={ind}
                                                                tipoDiaDiaSelecionado={tipoDiaDiaSelecionado}
                                                                setExpandiu={setExpandiu}
                                                            />
                                                        </GridItem2>
                                                    </GridContainer>
                                                )}
                                            </>
                                        )}

                                        {isXsDownScreen && values.diaDiaPagination.length - 1 !== ind && (
                                            <CardGridDividerElementos />
                                        )}
                                    </GridItem12>
                                )

                            } else {

                                return ''
                            }
                        })}
                    </GridContainer>

                    <TablePaginationPadraoDiaDia
                        values={values}
                        setFieldValue={setFieldValue}
                    />

                    <GridContainerGridItemButtonIncluirLinha>
                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirDiaDia}
                            align='right'
                            disabled={familiaresList(values).length === 0 ? true : false}
                            onClick={() => 
                                {
                                    incrementaContDiaDia(values)
                                    arrayHelpers.push({
                                        id: values.contDiaDia,
                                        familiar: HARDCODE.idFamiliarCliente,
                                    })
                                    setPageInclusaoDiaDia(values, setFieldValue)
                                }
                            }
                        />
                    </GridContainerGridItemButtonIncluirLinha>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default FormFormDiaDia